import { ACTIVE, INACTIVE } from "./state";
import mixins from "vue-typed-mixins";
import accountLookupResultMixin from "./accountLookupResultMixin";
import { featureToggleMixin, gtmMixin } from "@/mixins";
const Button = () => import("@/components/Button.vue");
const Card = () => import("@/components/composite/Card/Card.vue");
const ButtonActivateAccount = () => import("./ButtonActivateAccount.vue");
const statuses = {
    [ACTIVE]: "Sudah aktif",
    [INACTIVE]: "Belum Aktif",
};
const statusColors = {
    [INACTIVE]: "bg-warning-light",
    [ACTIVE]: "bg-green-20",
};
export default mixins(accountLookupResultMixin, featureToggleMixin, gtmMixin).extend({
    components: { Card, ButtonActivateAccount, Button },
    props: {
        alert: {
            type: Object,
            default: () => ({
                message: "",
                type: "",
            }),
        },
        account: {
            type: Object,
            required: true,
        },
    },
    computed: {
        statusText() {
            return statuses[this.account.status];
        },
        statusColorClass() {
            return statusColors[this.account.status];
        },
    },
    methods: {
        trackBtnAccess() {
            this.gtmClickButton("akses_akun");
        },
    },
});
